import React from 'react'
import { ButtonProps } from './Button.types'
import { StyledButton, IconWrapper } from './Button.styles'

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  loading = false,
  leftIcon,
  rightIcon,
  children,
  disabled,
  ...props
}) => {
  return (
    <StyledButton
      $variant={variant}
      $size={size}
      $fullWidth={fullWidth}
      $loading={loading}
      disabled={disabled || loading}
      {...props}
    >
      {leftIcon && !loading && <IconWrapper>{leftIcon}</IconWrapper>}
      {children}
      {rightIcon && !loading && <IconWrapper>{rightIcon}</IconWrapper>}
    </StyledButton>
  )
}
